module.exports = __webpack_public_path__ + "media/images/city_img/icon3-28cb69f34cf6cbb6a6c4d1e5eba3490c.png";